document.addEventListener("DOMContentLoaded", function() {
    // Calculate and set dynamic height for shade selector wrappers
    function updateShadeSelectorHeights() {
        const wrappers = document.querySelectorAll('.product-shade-selector_wrapperShades');
        
        wrappers.forEach((wrapper) => {
            const selector = wrapper.querySelector('.product-shade-selector_shadesSelector');
            
            if (selector) {
                // Get the first item to calculate row height
                const firstItem = selector.querySelector('a, button');
                
                if (firstItem) {
                    const itemHeight = firstItem.offsetHeight;
                    const itemTop = firstItem.offsetTop;
                    
                    // Find items in the first row
                    let itemsInFirstRow = 1;
                    
                    // Count items in first row
                    for (let i = 1; i < selector.children.length; i++) {
                        const item = selector.children[i];
                        if (item.offsetTop === itemTop) {
                            itemsInFirstRow++;
                        } else {
                            break;
                        }
                    }
                    
                    // Calculate first row height (including gaps)
                    const firstRowHeight = itemHeight
                    
                    // Store full height for later expansion
                    const contentHeight = selector.scrollHeight;
                    wrapper.dataset.fullHeight = contentHeight;
                    wrapper.dataset.firstRowHeight = firstRowHeight;
                    
                    // Set initial height to show only first row
                    wrapper.style.height = firstRowHeight + 'px';
                }
            }
        });
    }
    
    // Handle shades count button click to expand/collapse
    const shadesCountButtons = document.querySelectorAll('.product-shade-selector_shadesCount');
    
    shadesCountButtons.forEach((button) => {
        // Store original text
        button.dataset.originalText = button.textContent;
        
        button.addEventListener('click', function() {
            // Find parent structure and the wrapper
            const shadesHeader = this.closest('.product-shade-selector_shadesHeader__brdn5');
            const wrapper = shadesHeader.nextElementSibling;
            if (wrapper && wrapper.classList.contains('product-shade-selector_wrapperShades')) {
                const isExpanded = wrapper.dataset.isExpanded === 'true';
                
                if (isExpanded) {
                    // Collapse to first row
                    wrapper.style.height = wrapper.dataset.firstRowHeight + 'px';
                    wrapper.dataset.isExpanded = 'false';
                    this.textContent = this.dataset.originalText;
                } else {
                    // Expand to show all
                    wrapper.style.height = wrapper.dataset.fullHeight + 'px';
                    wrapper.dataset.isExpanded = 'true';
                    this.textContent = "Show less";
                }
            }
        });
    });
    
    // Call on load and on window resize
    updateShadeSelectorHeights();
    window.addEventListener('resize', updateShadeSelectorHeights);
    
    // Handle disclosure button functionality
    const disclosureButtons = document.querySelectorAll('.product-more-info_disclosureButton');
    
    disclosureButtons.forEach((button) => {
        button.addEventListener('click', function() {
            
            // Find the next panel element (sibling)
            const panel = this.nextElementSibling;
            
            // Check if this panel is already open
            const isExpandedState = this.getAttribute('data-headlessui-state') === 'open';
            
            // Close all other panels
            disclosureButtons.forEach((otherButton) => {
                if (otherButton !== this) {
                    otherButton.setAttribute('aria-expanded', 'false');
                    otherButton.setAttribute('data-headlessui-state', '');
                    
                    const otherPanel = otherButton.nextElementSibling;
                    if (otherPanel && otherPanel.classList.contains('product-more-info_disclosurePanel')) {
                        otherPanel.setAttribute('data-headlessui-state', '');
                    }
                    
                    const otherIcon = otherButton.querySelector('.icon_iconContainer__lS_O1 svg');
                    if (otherIcon) {
                        otherIcon.style.transform = 'rotate(0deg)';
                    }
                }
            });
            
            // Toggle current button
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);
            this.setAttribute('data-headlessui-state', isExpanded ? '' : 'open');
            
            // Toggle the panel's data-headlessui-state attribute
            if (panel && panel.classList.contains('product-more-info_disclosurePanel')) {
                panel.setAttribute('data-headlessui-state', isExpanded ? '' : 'open');
            }
            
            // Rotate the icon
            const icon = this.querySelector('.icon_iconContainer__lS_O1 svg');
            if (icon) {
                icon.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(180deg)';
            }
        });
    });
});


document.addEventListener('DOMContentLoaded', function () {

    // ─── Swiper not loaded guard ───────────────────────────────────────────────
    if (typeof Swiper === 'undefined') {
        console.error('Swiper is not loaded');
        return;
    }

    // ─── References ───────────────────────────────────────────────────────────
    let mainSwiper = null;
    let popupSwiper = null;

    const mainGalleryEl   = document.querySelector('.product-gallery_galleryCarousel');
    const thumbButtons    = document.querySelectorAll(
        '.product-gallery-navigator_navigatorContainer .product-gallery-navigator_navigatorButton'
    );
    const arrowPrev       = document.querySelector('.carousel-utils_arrowL__e_hk7');
    const arrowNext       = document.querySelector('.carousel-utils_arrowR__7AZ0v');
    const galleryButtons  = document.querySelectorAll('.product-gallery_galleryButton__S3y_y');
    const portalRoot      = document.getElementById('headlessui-portal-root');
    const popupDialog     = document.querySelector('.product-gallery_galleryDialog__b4AJu');

    // ─── Helper: is desktop? ──────────────────────────────────────────────────
    function isDesktop() {
        return window.innerWidth >= 900;
    }

    // ─── 1. Main Swiper Init / Re-init ────────────────────────────────────────
    function initMainSwiper() {
        if (!mainGalleryEl) return;

        mainSwiper = new Swiper(mainGalleryEl, {
            direction:     'horizontal',
            loop:          false,
            slidesPerView: 1,
            spaceBetween:  10,
            observer:      true,
            observeParents:true,
            on: {
                slideChange: function () {
                    syncThumbnails(mainSwiper.activeIndex);
                    updateArrowStates();
                },
                breakpoint: function () {
                    updateArrowStates();
                },
                resize: function () {
                    updateArrowStates();
                }
            },
            breakpoints: {
                900: {
                    direction: 'vertical'
                }
            }
        });

        syncThumbnails(mainSwiper.activeIndex);
        updateArrowStates();
    }

    // ─── 2. Thumbnail Sync ────────────────────────────────────────────────────
    function syncThumbnails(activeIndex) {
        thumbButtons.forEach(function (btn, i) {
            btn.classList.toggle('product-gallery-navigator_active', i === activeIndex);
            btn.setAttribute('aria-checked', i === activeIndex ? 'true' : 'false');
        });
    }

    // ─── Arrow Disable State ──────────────────────────────────────────────────
    function updateArrowStates() {
        if (!mainSwiper) return;
        const total = mainSwiper.slides ? mainSwiper.slides.length : 0;
        const idx   = mainSwiper.activeIndex;

        if (arrowPrev) {
            const isFirst = idx === 0;
            arrowPrev.disabled = isFirst;
            arrowPrev.setAttribute('aria-disabled', isFirst ? 'true' : 'false');
            arrowPrev.style.opacity       = isFirst ? '0.35' : '1';
            arrowPrev.style.pointerEvents = isFirst ? 'none' : 'auto';
        }

        if (arrowNext) {
            const isLast = idx === total - 1;
            arrowNext.disabled = isLast;
            arrowNext.setAttribute('aria-disabled', isLast ? 'true' : 'false');
            arrowNext.style.opacity       = isLast ? '0.35' : '1';
            arrowNext.style.pointerEvents = isLast ? 'none' : 'auto';
        }
    }

    // Thumbnail click → slide to that index
    thumbButtons.forEach(function (btn, index) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            if (mainSwiper) mainSwiper.slideTo(index);
        });
    });

    // ─── 3. Arrow Navigation ──────────────────────────────────────────────────
    if (arrowPrev) {
        arrowPrev.addEventListener('click', function () {
            if (mainSwiper) mainSwiper.slidePrev();
        });
    }

    if (arrowNext) {
        arrowNext.addEventListener('click', function () {
            if (mainSwiper) mainSwiper.slideNext();
        });
    }

    // ─── 4. Zoom Functionality (Main Gallery only) ────────────────────────────
    let customCursor = null;
    const ZOOM_LEVEL = 1.8;

    function getOrCreateCursor() {
        if (!customCursor) {
            customCursor = document.createElement('div');
            customCursor.id = 'custom-zoom-cursor';

            customCursor.innerHTML = [
                '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"',
                '     fill="none" stroke="rgba(0,0,0,0.72)" stroke-width="2.2"',
                '     stroke-linecap="round" stroke-linejoin="round">',
                '  <circle cx="11" cy="11" r="7"></circle>',
                '  <line x1="16.5" y1="16.5" x2="22" y2="22"></line>',
                '  <line x1="11" y1="8.5" x2="11" y2="13.5"></line>',
                '  <line x1="8.5" y1="11" x2="13.5" y2="11"></line>',
                '</svg>'
            ].join('');

            Object.assign(customCursor.style, {
                position:       'fixed',
                width:          '46px',
                height:         '46px',
                borderRadius:   '50%',
                pointerEvents:  'none',
                zIndex:         '10000',
                display:        'none',
                background:     'rgba(255,255,255,0.05)',
                boxShadow:      '0 2px 14px rgba(0,0,0,0.16)',
                transform:      'translate(-50%, -50%)',
                transition:     'opacity 0.12s',
                alignItems:     'center',
                justifyContent: 'center',
            });

            document.body.appendChild(customCursor);
        }
        return customCursor;
    }

    function moveCursor(x, y) {
        const cursor = getOrCreateCursor();
        cursor.style.left    = x + 'px';
        cursor.style.top     = y + 'px';
        cursor.style.display = 'flex';
    }

    function hideCursor() {
        if (customCursor) customCursor.style.display = 'none';
    }

    function applyZoom(img, btn) {
        img.style.transition      = 'transform 0.2s ease';
        img.style.transform       = 'scale(' + ZOOM_LEVEL + ')';
        img.style.transformOrigin = 'center center';
        btn.style.overflow        = 'hidden';
        btn.style.cursor          = 'none';
    }

    function resetZoom(img, btn) {
        img.style.transform       = 'scale(1)';
        img.style.transformOrigin = 'center center';
        btn.style.cursor          = 'default';
    }

    function updateZoomOrigin(img, btn, e) {
        const rect = btn.getBoundingClientRect();
        const pctX = ((e.clientX - rect.left) / rect.width)  * 100;
        const pctY = ((e.clientY - rect.top)  / rect.height) * 100;
        img.style.transformOrigin = pctX + '% ' + pctY + '%';
    }

    galleryButtons.forEach(function (btn) {
        if (popupDialog && popupDialog.contains(btn)) return;

        btn.addEventListener('mouseenter', function () {
            const img = this.querySelector('img');
            if (img) applyZoom(img, this);
        });

        btn.addEventListener('mousemove', function (e) {
            const img = this.querySelector('img');
            if (img) updateZoomOrigin(img, this, e);
            moveCursor(e.clientX, e.clientY);
        });

        btn.addEventListener('mouseleave', function () {
            const img = this.querySelector('img');
            if (img) resetZoom(img, this);
            hideCursor();
        });

        btn.addEventListener('mousedown', function () { this.style.cursor = 'none'; });
        btn.addEventListener('mouseup',   function () { this.style.cursor = 'none'; });
    });

    // ─── 5. Popup Open ────────────────────────────────────────────────────────
    galleryButtons.forEach(function (btn) {
        if (popupDialog && popupDialog.contains(btn)) return;

        btn.addEventListener('click', function (e) {
            e.preventDefault();

            const activeIndex = mainSwiper ? mainSwiper.activeIndex : 0;

            if (!portalRoot || !popupDialog) return;

            const img = this.querySelector('img');
            if (img) resetZoom(img, this);
            hideCursor();

            portalRoot.style.display = 'block';
            portalRoot.setAttribute('data-headlessui-portal-state', 'open');
            document.body.style.overflow = 'hidden';

            const popupSwiperEl = popupDialog.querySelector('.swiper');

            if (popupSwiperEl) {
                if (popupSwiperEl.swiper) {
                    popupSwiperEl.swiper.slideTo(activeIndex, 0);
                    popupSwiper = popupSwiperEl.swiper;
                } else {
                    popupSwiper = new Swiper(popupSwiperEl, {
                        direction:     'horizontal',
                        loop:         false,
                        slidesPerView: 1,
                        initialSlide: activeIndex,
                        on: {
                            slideChange: function () {
                                syncThumbnails(mainSwiper.activeIndex);
                                updateArrowStates();
                            },
                            breakpoint: function () {
                                updateArrowStates();
                            },
                            resize: function () {
                                updateArrowStates();
                            }
                        },
                        breakpoints: {
                            900: {
                                direction: 'vertical'
                            }
                        }
                    });
                }

                syncPopupThumbnails(activeIndex);

                if (popupSwiper) {
                    popupSwiper.off('slideChange');
                    popupSwiper.on('slideChange', function () {
                        syncPopupThumbnails(popupSwiper.activeIndex);
                    });
                }
            }

            const closeBtn = popupDialog.querySelector('.product-gallery_galleryPanelClose__ySOUG');
            if (closeBtn) {
                closeBtn.onclick = function () {
                    portalRoot.style.display = 'none';
                    portalRoot.setAttribute('data-headlessui-portal-state', '');
                    document.body.style.overflow = 'auto';
                };
            }
        });
    });

    // ─── 6. Popup Thumbnail Sync ──────────────────────────────────────────────
    function syncPopupThumbnails(activeIndex) {
        if (!popupDialog) return;
        const popupThumbs = popupDialog.querySelectorAll('.product-gallery-navigator_navigatorButton');
        popupThumbs.forEach(function (btn, i) {
            btn.classList.toggle('product-gallery-navigator_active', i === activeIndex);
            btn.setAttribute('aria-checked', i === activeIndex ? 'true' : 'false');
        });
    }

    if (popupDialog) {
        const popupThumbs = popupDialog.querySelectorAll('.product-gallery-navigator_navigatorButton');
        popupThumbs.forEach(function (btn, index) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                if (popupSwiper) popupSwiper.slideTo(index);
            });
        });

        const popupArrowPrev = popupDialog.querySelector('.carousel-utils_arrowL__e_hk7');
        const popupArrowNext = popupDialog.querySelector('.carousel-utils_arrowR__7AZ0v');
        if (popupArrowPrev) {
            popupArrowPrev.addEventListener('click', function () {
                if (popupSwiper) popupSwiper.slidePrev();
            });
        }
        if (popupArrowNext) {
            popupArrowNext.addEventListener('click', function () {
                if (popupSwiper) popupSwiper.slideNext();
            });
        }
    }

    // ─── 7. Initial Init ──────────────────────────────────────────────────────
    initMainSwiper();

    // ─── 8. Resize → Re-init if breakpoint crossed ───────────────────────────
});



// ─── Variant Selection + Section Rerender ────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {

  const shadeButtons = document.querySelectorAll(
    '.product-shade-selector_shadeSelectorButton__RJJvK'
  );

  shadeButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const variantId = this.dataset.id;
      if (!variantId) return;

      // 1. URL update (without reload)
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);

      // 2. Section Rendering API call
      fetch(
        `${window.location.pathname}?variant=${variantId}&section_id=${window.cosmeticsProductSectionId}`
      )
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
            console.log(doc)
          // --- Background color CSS variable ---
          const newStyle = doc.querySelector('style');
          if (newStyle) {
            const existingStyle = document.querySelector(
              'style[data-variant-style]'
            );
            const styleEl =
              existingStyle || document.createElement('style');
            styleEl.setAttribute('data-variant-style', '');
            styleEl.textContent = newStyle.textContent;
            if (!existingStyle) document.head.appendChild(styleEl);
          }

          // --- Variant title (color name) ---
          const newColorName = doc.querySelector(
            '.product-shade-selector_colorName__Hq26z'
          );
          const existingColorName = document.querySelector(
            '.product-shade-selector_colorName__Hq26z'
          );
          if (newColorName && existingColorName) {
            existingColorName.textContent = newColorName.textContent;
          }

          // --- Price (all instances) ---
            const newPricesWrapper = doc.querySelectorAll(
            '.product-stacked-price_priceInfo__Imdcp'
            );
            const existingPricesWrapper = document.querySelectorAll(
            '.product-stacked-price_priceInfo__Imdcp'
            );

            existingPricesWrapper.forEach((existing, index) => {
                const newPrice = newPricesWrapper[index];
                if (newPrice) {
                    existing.innerHTML = newPrice.innerHTML;
                }
            });
          // --- product action (all instances) ---
            const newActionWrapper = doc.querySelectorAll(
            '.product-actions_wrapper'
            );
            const existingActionWrapper = document.querySelectorAll(
            '.product-actions_wrapper'
            );

            existingActionWrapper.forEach((existing, index) => {
                const newWrapper = newActionWrapper[index];
                if (newWrapper) {
                    existing.innerHTML = newWrapper.innerHTML;
                    
                    // ✅ YEH LINE ADD KARO — variant id update karo wrapper pe
                    const newVariantId = newWrapper.dataset.variantId;
                    if (newVariantId) {
                        existing.dataset.variantId = newVariantId;
                    }
                    
                    delete existing.dataset.cartInitialized;
                }
            });
            window.productCart.reinitWrappers();
            
          // --- Active shade button state ---
          document
            .querySelectorAll(
              '.product-shade-selector_shadeSelectorButton__RJJvK, .product-shade-selector_selectedShadeSelectorButtonv'
            )
            .forEach(b => {
              b.classList.remove(
                'product-shade-selector_selectedShadeSelectorButtonv'
              );
              b.classList.add(
                'product-shade-selector_shadeSelectorButton__RJJvK'
              );
              b.setAttribute('aria-checked', 'false');
            });

          // Mark clicked one as selected
          this.classList.remove(
            'product-shade-selector_shadeSelectorButton__RJJvK'
          );
          this.classList.add(
            'product-shade-selector_selectedShadeSelectorButtonv'
          );
          this.setAttribute('aria-checked', 'true');
        })
        .catch(err => console.error('Variant rerender error:', err));
    });
  });
  function getCollectionForBreadcrumb() {
  const referrer = document.referrer;
  const collectionMatch = referrer.match(/\/collections\/([^/?#]+)/);

  if (collectionMatch) {
    return {
      handle: collectionMatch[1],
      title: null
    };
  }

  return {
    handle: window.__productCollections?.[0]?.handle || null,
    title: window.__productCollections?.[0]?.title || null
  };
}

function initBreadcrumb() {
  const { handle, title } = getCollectionForBreadcrumb();

  if (!handle) return;

  const collections = window.__productCollections || [];
  const matched = collections.find(c => c.handle === handle);

  const collectionTitle = matched?.title || title || handle.replace(/-/g, ' ');
  const collectionUrl = matched?.url || `/collections/${handle}`;

  const link = document.querySelector('.hh-breadcrumb-collection');
  const label = document.querySelector('.hh-breadcrumb-collection-title');

  if (link) link.href = collectionUrl;
  if (label) label.textContent = collectionTitle;
}

initBreadcrumb();
});